export function numberToInput(value: number | undefined | null): string {
  return value == null ? '' : String(value).replace('.', ',');
}
